module.exports = __webpack_public_path__ + "img/00048.80bff8c0.webp";